export function sidebarFilters() {
  if (window.innerWidth < '1023') {
    const filters = document.querySelector('.filters');
    const pagetitle = document.querySelector('.page-title');

    if (filters) {
      // clone filters
      const filtersClone = filters.cloneNode(true);
      // add cloned filters after title
      const newFilters = pagetitle.appendChild(filtersClone);
      newFilters.classList.add('mt-5');
      // remove original filters
      filters.remove();
      // open filters if clicked on title
      filtersClone.querySelectorAll('.js-filter-title').forEach((item) => {
        item.addEventListener('click', () => {
          item.nextSibling.classList.toggle('open');
        });
      });
    }
  }
}
